
<span class="page-not-found">
    <h1 class="educational-module__title">404</h1>
    <h4>Что-то пошло не так. Запрашиваемая вами страница не найдена!</h4>
    <button (click)="mainPageButtonHandler()" mat-raised-button color="primary">
        На главную
    </button>
</span>
